import { Hit } from '@cfra-nextgen-frontend/shared/src/components/TypeSearch/types/opensearch';
import { getSumOfAllValues } from '@cfra-nextgen-frontend/shared/src/utils/arrays';
import { ApiNames, RequestTypes } from '@cfra-nextgen-frontend/shared/src/utils/enums';

export type AccessibilitySecurity = {
    sppw_id: number;
    ticker: string;
    name: string;
    exchange: string;
    security_type: string;
    report_ind: string;
    value: string;
    ticker_full: string;
    region: string;
    cusip?: string;
    isin?: string;
    holding_asset_class?: string; // ETF securities: "Equity" | "Fixed Income"
    category_name?: string;       // Fund securities: "Equity" | "Fixed Income (Bonds)"
};

// The Accessibility search API returns a flat array of hit objects
export type AccessibilitySearchResponse = Array<Hit<AccessibilitySecurity>>;

export const SECURITY_SUGGESTER_PATH = 'search';

export const SECURITY_SUGGESTER_SIZE = 25;

export function getSecuritySuggesterInfiniteRequestParamsConfig(size: number) {
    return {
        requestType: RequestTypes.GET,
        apiName: ApiNames.Wealth,
        getNextPageParam: (lastPage: unknown, allPages: Array<unknown>) => {
            const lastPageLength = (lastPage as AccessibilitySearchResponse)?.length;

            if (!lastPageLength || lastPageLength < size) {
                return undefined;
            }

            return getSumOfAllValues(
                allPages.map((page) => (page as AccessibilitySearchResponse)?.length || 0),
            );
        },
    };
}
